"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFileDto = instanceOfFileDto;
exports.FileDtoFromJSON = FileDtoFromJSON;
exports.FileDtoFromJSONTyped = FileDtoFromJSONTyped;
exports.FileDtoToJSON = FileDtoToJSON;
exports.FileDtoToJSONTyped = FileDtoToJSONTyped;
/**
 * Check if a given object implements the FileDto interface.
 */
function instanceOfFileDto(value) {
    if (!('href' in value) || value['href'] === undefined)
        return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined)
        return false;
    return true;
}
function FileDtoFromJSON(json) {
    return FileDtoFromJSONTyped(json, false);
}
function FileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'href': json['href'],
        'mimeType': json['mimeType'],
        'sizeInBytes': json['sizeInBytes'] == null ? undefined : json['sizeInBytes'],
    };
}
function FileDtoToJSON(json) {
    return FileDtoToJSONTyped(json, false);
}
function FileDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'href': value['href'],
        'mimeType': value['mimeType'],
        'sizeInBytes': value['sizeInBytes'],
    };
}
//# sourceMappingURL=FileDto.js.map